import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useActiveComponent } from '../ActiveComponentContext.js';
import { useAuth } from '../../contexts/AuthContext/index.jsx';
import { generatePath } from '../../utils/categoryUtils/index.js';
import { categoryList } from '../../Data/pageData.jsx';
import {
  useMediaQuery,
  useTheme,
  Box,
  Tooltip,
  TextField,
  Button,
} from '@mui/material';
import AccordionExpand from '../Accordian';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import FacebookIcon from '@mui/icons-material/Facebook';
import EmailIcon from '@mui/icons-material/Email';
import MessageIcon from '@mui/icons-material/Message';
import XIcon from '@mui/icons-material/X';
import LinkIcon from '@mui/icons-material/Link';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import Badge from '@mui/material/Badge';
import { db } from '../../Firebase/firebase';
import { setDoc, doc } from 'firebase/firestore';
//import TextField from '@mui/material';

const LargePostCardDialog = ({
  images = [], //array of images
  title,
  summary,
  id,
  postID,
  postInfo,
  photoURL,
  username,
  name,
  email,
  date,
  category,
  country,
  vertical = '550px',
  horizontal = '780px',
  isEditable,
  cardData,
  onClose,
  onSave,
  navigateToCategory, // Add the navigation function prop
}) => {
  const {
    currentUser,
    setShowAlertDialog,
    setIsBookmarkForAlert,
    bookmarkCount,
    bookmarks,
    toggleBookmark,
    //updateUserPost,
  } = useAuth();
  const { setActivePath } = useActiveComponent();
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md')); // breakpoints for where screen size is decided
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const [currentIndex, setCurrentIndex] = useState(0); // Index for the current image
  const isBookmarked = bookmarks[postID] || false; // Check if this post is bookmarked
  const [commentsCount, setCommentsCount] = useState(0);
  const [editedTitle, setEditedTitle] = useState(title || '');
  const [editedSummary, setEditedSummary] = useState(summary || '');

  const navigate = useNavigate();

  const handleSave = () => {
    try {
      const updatedData = {
        ...cardData,
        title: editedTitle,
        description: editedSummary,
      };
      onSave(updatedData); // Notify parent to update the post
      //console.log('Post changes sent to parent for saving!');
    } catch (error) {
      console.error('Error in save handler:', error);
    }
  };

  const handleCommentsCountChange = (count) => {
    setCommentsCount(count);
  };

  //send you to respective category page when clicked
  const handleCategoryClick = (category) => {
    const path = generatePath(category);
    setActivePath(path); // Update the active path
    navigate(path);
  };

  //FUNCTIONS,
  const getCategoryIcon = (categoryName) => {
    const categoryItem = categoryList.find(
      (item) => item.name === categoryName
    );
    return categoryItem ? categoryItem.icon : null;
  };

  const handleNextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };
  const handlePrevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  //Opens post in its own page
  const handleClick = () => {
    navigate(`/post/${postID}`, {
      state: {
        images,
        title,
        summary,
        name,
        date,
        category,
        country,
      },
    });
  };
  //Handle navigation to username page, when it's clicked
  const handleUsernameClick = (path) => {
    navigate(path);
    setActivePath(path);
  };

  const handleShare = (platform) => {
    const postUrl = `${window.location.origin}/posts/${postID}`;
    let shareUrl = '';
    const shareText = `${title}\n\n${summary}\n\n${postUrl}`; // Including title, summary, and URL

    switch (platform) {
      case 'twitter':
        shareUrl = `https://twitter.com/share?url=${encodeURIComponent(
          postUrl
        )}&text=${encodeURIComponent(title)}`;
        break;
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          postUrl
        )}&quote=${encodeURIComponent(shareText)}`;
        break;
      case 'email':
        shareUrl = `mailto:?subject=${encodeURIComponent(
          title
        )}&body=${encodeURIComponent(shareText)}`;
        break;
        break;
      case 'message':
        shareUrl = `sms:?body=${encodeURIComponent(shareText)}`;

        break;
      case 'copy':
        navigator.clipboard.writeText(postUrl);
        alert('Link copied to clipboard!');
        return;
      default:
        break;
    }
    if (shareUrl) {
      window.open(shareUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleBookmarkClick = async () => {
    if (!currentUser) {
      setShowAlertDialog(true);
      setIsBookmarkForAlert(true);
      return;
    }
    // Pass required post details when adding a bookmark
    toggleBookmark(postID, {
      creatorsUserId: id || null,
      title,
      summary,
      images,
      photoURL,
      username,
      //name,
      date,
      category,
      country: country || null,
      //city:city || null
    });
  };

  // Set height conditionally based on screen size
  const height = isMdUp && isLgUp ? vertical : '200px';
  const cardWidth = isMdUp && isLgUp ? horizontal : '300px';
  const maxWidth = 1900;

  return (
    <Card
      sx={{
        maxWidth: 1900,
        width: {
          xs: '100%',
          sm: '100%',
          md: maxWidth,
          lg: maxWidth,
          xl: maxWidth,
        },
        boxSizing: 'border-box',
        ml: 0,
        mr: 0,
        p: { xs: 1.5, sm: 1.5, md: 2, lg: 2.5, xl: 2.5 },
        overflowY: 'auto',
        borderRadius: 4,
        display: 'flex',
        flexDirection: {
          xs: 'column',
          sm: 'column',
          md: 'row',
          lg: 'row',
          xl: 'row',
        },
      }}
    >
      {images && images.length > 0 ? (
        <Box position='relative'>
          <CardMedia
            component='img'
            image={images[currentIndex]}
            alt='post image'
            sx={{
              objectFit: 'cover',
              width: { lg: '600px', xl: '600px' },
              height: {
                xs: '200px',
                sm: '200px',
                md: '90%',
                lg: '98%',
                xl: '98%',
              },
              borderRadius: 4,
            }}
          />
          {images.length > 1 && (
            <Box>
              <IconButton
                disableRipple
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '10px',
                  transform: 'translateY(-50%)',
                  color: '#030202',
                  backgroundColor: 'white',
                  '&:hover': {
                    color: 'white',
                    backgroundColor: 'dimgrey',
                    boxShadow: '0px 2px 3px grey',
                  },
                }}
                onClick={handlePrevImage}
              >
                <ArrowBackIosIcon
                  sx={{ fontSize: { xs: 8, sm: 8, md: 12, lg: 14, xl: 14 } }}
                />
              </IconButton>
              <IconButton
                disableRipple
                sx={{
                  position: 'absolute',
                  top: '50%',
                  right: '10px',
                  transform: 'translateY(-50%)',
                  color: '#030202',
                  backgroundColor: 'white',
                  '&:hover': {
                    color: 'white',
                    backgroundColor: 'dimgrey',
                    boxShadow: '0px 2px 3px grey',
                  },
                }}
                onClick={handleNextImage}
              >
                <ArrowForwardIosIcon
                  sx={{ fontSize: { xs: 8, sm: 8, md: 12, lg: 14, xl: 14 } }}
                />
              </IconButton>
            </Box>
          )}
        </Box>
      ) : (
        <Box>
          {/* <Box
          gap={2}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        > */}
          {/* </Box> */}
          <Typography
            variant='h6'
            sx={{
              fontSize: { xs: 13, sm: 13, md: 14, lg: 16, xl: 16 },
              mt: 2,
              ml: 1,
              mb: 0.5,
              fontFamily: 'Montserrat',
              fontWeight: '600',
            }}
          >
            Description
          </Typography>
          {isEditable ? (
            <TextField
              label='Summary'
              value={editedSummary}
              onChange={(e) => setEditedSummary(e.target.value)}
              fullWidth
              margin='normal'
              multiline
              rows={4}
              InputProps={{
                sx: {
                  fontFamily: 'Montserrat',
                  fontSize: { xs: 11, sm: 11, md: 13, lg: 13, xl: 13 },
                  // backgroundColor: "black",
                  // color: "white",
                  borderRadius: 4,
                  p: 2,
                },
              }}
            />
          ) : (
            <Typography
              variant='body2'
              color='text.secondary'
              sx={{
                display: 'flex',
                textAlign: 'flex-start',
                width: { lg: '600px', xl: '600px' },
                height: {
                  xs: 'auto',
                  sm: 'auto',
                  md: 'auto',
                  lg: 'auto',
                  xl: 'auto',
                },
                maxHeight: {
                  xs: '200px',
                  sm: '200px',
                  md: '80%',
                  lg: '80%',
                  xl: '80%',
                },
                overflowY: 'auto',
                borderRadius: 4,
                fontFamily: 'Montserrat',
                backgroundColor: 'black',
                color: 'white',
                m: 0,
                ml: 0,
                mr: 0,
                mt: { xs: 0.5, sm: 0.5, md: 0.5, lg: 0, xl: 0 },
                mb: 1,
                p: 2,
                fontSize: { xs: 11, sm: 11, md: 13, lg: 13, xl: 13 },
                whiteSpace: 'pre-line',
                '&:hover': {
                  boxShadow: '0px 1px 2px inset grey',
                  cursor: 'grab',
                },
                '&::-webkit-scrollbar': {
                  width: '8px',
                  backgroundColor: 'transparent',
                },
                '&:hover::-webkit-scrollbar': {
                  backgroundColor: '#e0e0e0',
                },
                '&:hover::-webkit-scrollbar-thumb': {
                  backgroundColor: '#888',
                  borderRadius: '10px',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  backgroundColor: '#555',
                },
              }}
            >
              {summary}
            </Typography>
          )}
        </Box>
      )}
      {/* Below image, all other content */}
      <CardContent
        sx={{
          margin: { xs: 0, sm: 0, md: 1, lg: 0.5, xl: 0.5 },
          height: '90%',
          width: { xs: 'auto', sm: 'auto', md: '50%', lg: '50%', xl: '50%' },
        }}
      >
        <Box
          gap={2}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          {isEditable ? (
            <TextField
              label='Title'
              value={editedTitle}
              onChange={(e) => setEditedTitle(e.target.value)}
              fullWidth
              margin='normal'
              InputProps={{
                sx: {
                  fontFamily: 'Montserrat',
                  fontSize: { xs: 13, sm: 13, md: 14, lg: 16, xl: 16 },
                  fontWeight: 600,
                },
              }}
            />
          ) : (
            <Typography
              gutterBottom
              variant='h6'
              sx={{
                display: 'flex',
                textAlign: 'flex-start',
                maxHeight: { xs: 40, sm: 40, md: 50, lg: 80, xl: 90 },
                overflowY: 'auto',
                fontSize: { xs: 13, sm: 13, md: 14, lg: 16, xl: 16 },
                fontWeight: '600',
                cursor: 'pointer',
                fontFamily: 'Montserrat',
              }}
            >
              {title}
            </Typography>
          )}
        </Box>

        {!isEditable && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              mt: 0,
              mb: 0,
              ml: 0,
              mr: 0,
              width: {
                xs: '250px',
                sm: '250px',
                md: '300px',
                lg: 'auto',
                xl: 'auto',
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography
                variant='body1'
                sx={{
                  display: 'flex',
                  mt: 1,
                  mb: 1.2,
                  gap: 1,
                  fontSize: { xs: 10, sm: 10, md: 12, lg: 13, xl: 13 },
                  background: 'rgb(240,240,240)',
                  cursor: 'pointer',
                  color: '#030202',
                  borderRadius: 4,
                  fontFamily: 'Montserrat',
                  pt: 0.3,
                  pb: 0.3,
                  pl: 1.5,
                  pr: 1.5,
                  alignItems: 'flex-end',
                  '&:hover': {
                    cursor: 'pointer',
                    textShadow: '0px 0px 0.5px blue',
                  },
                }}
                onClick={() => handleCategoryClick(category)} // Handle category click
              >
                {getCategoryIcon(category)}
                {category}
              </Typography>
            </Box>

            <Tooltip title={isBookmarked ? 'Unsave Post' : 'Save Post'}>
              <Badge
                badgeContent={bookmarkCount}
                color='primary'
                sx={{
                  '& .MuiBadge-badge': {
                    transform: 'translate(-50%, 20%)', // Adjust the percentage values as needed
                    fontSize: {
                      xs: '0.5rem',
                      sm: '0.5rem',
                      md: '0.5rem',
                      lg: '0.6rem',
                      xl: '0.6rem',
                    }, // Adjust font size
                    width: {
                      xs: '12px',
                      sm: '13px',
                      md: '15px',
                      lg: '17px',
                      xl: '17px',
                    }, // Adjust width
                    height: {
                      xs: '12px',
                      sm: '13px',
                      md: '15px',
                      lg: '17px',
                      xl: '17px',
                    }, // Adjust height
                    minWidth: {
                      xs: '10px',
                      sm: '13px',
                      md: '15px',
                      lg: '17px',
                      xl: '17px',
                    }, // Ensures the badge keeps its shape
                    color: 'white',
                    backgroundColor: 'crimson',
                    boxShadow: '1px 1px 1px grey',
                  },
                }}
              >
                <IconButton disableRipple onClick={handleBookmarkClick}>
                  {isBookmarked ? (
                    <BookmarkIcon
                      sx={{
                        fontSize: { xs: 19, sm: 22, md: 22, lg: 26, xl: 26 },
                        mt: 0,
                        color: 'crimson',
                      }}
                    />
                  ) : (
                    <BookmarkBorderIcon
                      sx={{
                        fontSize: { xs: 19, sm: 22, md: 22, lg: 26, xl: 26 },
                        mt: 0,
                        color: 'crimson',
                        '&:hover': {
                          transform: 'scale(1.11)', // Optional: adds a slight zoom effect
                          transition:
                            'transform 0.5s ease-in-out, box-shadow 0.3s ease-in-out',
                        },
                      }}
                    />
                  )}
                </IconButton>
              </Badge>
            </Tooltip>
          </Box>
        )}

        {images.length > 0 && (
          <Box>
            <Typography
              variant='h6'
              sx={{
                fontSize: { xs: 13, sm: 13, md: 14, lg: 16, xl: 16 },
                mt: 1,
                ml: 1,
                mb: 0.5,
                fontFamily: 'Montserrat',
              }}
            >
              Description
            </Typography>

            {isEditable ? (
              <TextField
                label='Summary'
                value={editedSummary}
                onChange={(e) => setEditedSummary(e.target.value)}
                fullWidth
                margin='normal'
                multiline
                rows={4}
                InputProps={{
                  sx: {
                    fontFamily: 'Montserrat',
                    fontSize: { xs: 11, sm: 11, md: 13, lg: 13, xl: 13 },
                    // backgroundColor: "black",
                    // color: "white",
                    borderRadius: 4,
                    p: 2,
                  },
                }}
              />
            ) : (
              <Typography
                variant='body2'
                color='text.secondary'
                sx={{
                  display: 'flex',
                  textAlign: 'flex-start',
                  maxHeight: { xs: 80, sm: 80, md: 120, lg: 120, xl: 120 },
                  overflowY: 'auto',
                  borderRadius: 2,
                  fontFamily: 'Montserrat',
                  m: 0,
                  ml: 0,
                  mr: 0,
                  mt: { xs: 0.5, sm: 0.5, md: 0.5, lg: 0, xl: 0 },
                  mb: 1,
                  p: 1,
                  pb: 1,
                  fontSize: { xs: 11, sm: 11, md: 13, lg: 13, xl: 13 },
                  whiteSpace: 'pre-line', // This will preserve line breaks and spaces
                  '&:hover': { boxShadow: '0px 1px 2px inset grey' },
                  '&::-webkit-scrollbar': {
                    width: '8px', // Width of the scrollbar
                    backgroundColor: 'transparent', // Hide scrollbar background by default
                  },
                  '&:hover::-webkit-scrollbar': {
                    backgroundColor: '#e0e0e0', // Show the scrollbar on hover
                  },
                  '&:hover::-webkit-scrollbar-thumb': {
                    backgroundColor: '#888', // Show the scrollbar on hover
                    borderRadius: '10px', // Round the corners of the scrollbar thumb
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#555', // Darker color when hovered over the scrollbar thumb
                  },
                }}
              >
                {summary}
              </Typography>
            )}
          </Box>
        )}

        {!isEditable && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                pl: 1,
              }}
            >
              <Typography
                onClick={() => handleUsernameClick(`/${username}`)}
                variant='body1'
                color='text.secondary'
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  fontFamily: 'Montserrat',
                  fontSize: { xs: 10, sm: 10, md: 10, lg: 12, xl: 12 },
                  '&:hover': {
                    cursor: 'pointer',
                    textShadow: '0px 0px 0.5px black',
                  },
                }}
              >
                {photoURL && (
                  <IconButton
                    sx={{
                      p: 0,
                      '&:hover': {
                        p: 0,
                      },
                    }}
                  >
                    <Avatar
                      alt={name || 'User'}
                      src={photoURL || null}
                      sx={{
                        width: { xs: 16, sm: 16, md: 18, lg: 24, xl: 24 },
                        height: { xs: 16, sm: 16, md: 18, lg: 24, xl: 24 },
                        mr: 0.5,
                        ml: 0.1,
                        mb: 0.2,
                        fontSize: { xs: 9, sm: 9, md: 10, lg: 11, xl: 11 },
                        bgcolor: photoURL ? 'crimson' : 'violet',
                        '&:hover': {
                          cursor: 'pointer',
                          boxShadow: '0px 0px 4px black',
                        },
                      }}
                    >
                      {!photoURL && (name?.[0] || email?.[0] || 'U')}
                    </Avatar>
                  </IconButton>
                )}
                {username}
              </Typography>
            </Box>
            <Typography
              variant='body1'
              color='text.secondary'
              sx={{
                mt: 0,
                mr: 1,
                fontSize: { xs: 9, sm: 9, md: 10, lg: 11, xl: 11 },
                fontFamily: 'Montserrat',
              }}
            >
              {date}
            </Typography>
          </Box>
        )}

        {!isEditable && (
          <Typography
            variant='h6'
            sx={{
              fontSize: { xs: 13, sm: 13, md: 14, lg: 16, xl: 16 },
              mt: 1,
              ml: 1,
              fontFamily: 'Montserrat',
            }}
          >
            Share
          </Typography>
        )}
        {/* <Box sx={{ display: 'flex', justifyContent: 'space-between' }}></Box> */}

        {/* Icons for sending links and bookmark */}
        {!isEditable && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mt: 0,
              mb: 0,
              ml: 0,
              mr: 0,
              pr: 1,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <IconButton onClick={() => handleShare('facebook')}>
                <FacebookIcon
                  sx={{
                    color: 'blue',
                    fontSize: { xs: 20, sm: 20, md: 18, lg: 24, xl: 26 },
                  }}
                />
              </IconButton>
              <IconButton onClick={() => handleShare('twitter')}>
                <XIcon
                  sx={{
                    color: 'white',
                    backgroundColor: 'black',
                    fontSize: { xs: 14, sm: 13, md: 13, lg: 17, xl: 19 },
                  }}
                />
              </IconButton>
              <IconButton onClick={() => handleShare('email')}>
                <EmailIcon
                  sx={{
                    color: 'coral',
                    fontSize: { xs: 20, sm: 17, md: 17, lg: 23, xl: 25 },
                  }}
                />
              </IconButton>
              <IconButton onClick={() => handleShare('message')}>
                <MessageIcon
                  sx={{
                    color: 'green',
                    fontSize: { xs: 18, sm: 15, md: 15, lg: 21, xl: 23 },
                  }}
                />
              </IconButton>
              <IconButton onClick={() => handleShare('copy')}>
                <LinkIcon
                  sx={{
                    color: 'indigo',
                    fontSize: { xs: 21, sm: 20, md: 20, lg: 23, xl: 23 },
                    transform: 'rotate(-45deg)',
                  }}
                />
              </IconButton>
            </Box>
          </Box>
        )}

        {isEditable && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'end',
              ml: 'auto',
              width: { xs: '10%', lg: '30%', xl: '30%' },
            }}
          >
            <Button
              variant='contained'
              color='primary'
              //type='submit'
              onClick={handleSave}
              // style={{ marginTop: "16px" }}
              sx={{
                mt: 0.8,
                ml: 'auto',
                fontSize: { xs: 8, sm: 8, md: 8, lg: 10, xl: 10 },
                backgroundColor: 'darkblue',
                borderRadius: '16px',
              }}
            >
              Save Changes
            </Button>
          </Box>
        )}

        {!isEditable && (
          <>
            <Typography
              variant='h6'
              sx={{
                fontSize: { xs: 13, sm: 13, md: 14, lg: 16, xl: 16 },
                mt: 0,
                ml: 1,
                fontFamily: 'Montserrat',
              }}
            >
              Comments ({commentsCount})
            </Typography>

            <AccordionExpand
              postId={postID}
              onCommentsCountChange={handleCommentsCountChange}
            />
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default LargePostCardDialog;

//No longer used/needed:

//const { postCategory } = postInfo; // Extract category from postInfo
// const [hover, setHover] = useState(false);
// const [isBookmark, setIsBookmark] = useState(false);
//const location = useLocation();

// const handleSave = async () => {
//   try {
//     const postRef = doc(db, 'posts', cardData.id); // Reference the specific post
//     const updatedData = {
//       ...cardData,
//       title: editedTitle,
//       description: editedSummary,
//     };
//     // Update post in Firebase
//     await setDoc(postRef, updatedData, { merge: true });

//     // Notify parent or context to refresh data if necessary
//     onSave(updatedData); // Call parent function to update local state (optional)

//     console.log('Post updated successfully!');
//   } catch (error) {
//     console.error('Error updating post:', error);
//   }
// };
